export enum WaCoexistenceContactImportLocalStorageIds {
  WA_COEXISTENCE_CONTACT_IMPORT_MODAL_WAS_SHOWN = 'wa_coexistence_contact_import_modal_was_shown',
}
